
import { toast } from 'react-toastify';

import {
  getCreditPurchases,
  postCreditPurchases
} from "../api/bernabeu";

import {
    creditPurchaseSlice,
    callTypes
  } from "../../redux/reducers/creditPurchaseSlice";

  const { actions } = creditPurchaseSlice;

const createCreditPurchase = (packageId, amount, paymentMethod, metadata = {}, clientCardId = null, couponId = null) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    let params: any = {
      package_id: packageId,
      amount: amount,
      payment_method: paymentMethod,
      metadata: metadata,
    };

    if (clientCardId) {
      params.client_card_id = clientCardId;
    }

    if (couponId) {
      params.coupon_id = couponId;
    }

    postCreditPurchases(params).then((response: any) => {
      dispatch(actions.creditPurchaseCreated());

      resolve(response);
    }).catch((error) => {
      console.log('createCreditPurchase falhou:');
      console.log({error});

      dispatch(actions.catchError({ error, callType: callTypes.action }));

      let message = error.response?.data?.message ?? 'Tente novamente';

      toast.error(message);

      reject(false);
    });
  });
}

const fetchCreditPurchases = (params = {}) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    getCreditPurchases(params).then((response: any) => {
      resolve(response.data);

      dispatch(actions.creditPurchaseFetched());

    }).catch((error) => {
      console.log('fetchCreditPurchases falhou:');
      console.log({error});

      dispatch(actions.creditPurchaseFetched());

      reject(false);
    });
  });
}

const fetchCreditPurchase = (id) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    getCreditPurchases({ id: id }).then((response: any) => {
      resolve(response.data[0]);

      dispatch(actions.creditPurchaseFetched());
    }).catch((error) => {
      console.log('fetchCreditPurchases falhou:');
      console.log({error});
      dispatch(actions.creditPurchaseFetched());

      reject(false);
    });
  });
}

export {
  createCreditPurchase,
  fetchCreditPurchases,
  fetchCreditPurchase,
}